import { observer } from "mobx-react-lite";
import * as React from "react";
import { Obj2Content } from "../../Obj2Tab/Obj2Content";
import { ObjNodeEditor } from "../../Obj2Tab/ObjNodeEditor";
import { ObjectsStore } from "../facade";
import { ResourceView } from "../view/statusView";

interface PropsObjectsContent {
  store: ObjectsStore;
}

/**
 * Правая часть экрана.
 *
 * Формы получают узел только когда данные для них готовы: до этого показывается
 * ожидание, а при отказе — причина и кнопка повтора. Ошибка одного объекта
 * остаётся его ошибкой, остальное дерево продолжает работать.
 */
export const ObjectsContent: React.FC<PropsObjectsContent> = observer(
  ({ store }) => (
    <ResourceView state={store.nodeData} onRetry={() => store.retry()}>
      {() => {
        const node = store.curNode;
        if (!node) return null;
        return node.type === "obj" ? (
          <Obj2Content node={node} store={store.ports} />
        ) : (
          <ObjNodeEditor curNode={node} store={store.ports} />
        );
      }}
    </ResourceView>
  ),
);
